import React from 'react';
import Particles from 'react-particles-js';
import params from '../../../assets/config/particles.config.json'
import Juxtapose from './juxtapose';
import Hexagons from './hexagons';
const HomeJuxtapose = () => (
    <section id="section-2" className="section-c section-2">
        <Juxtapose></Juxtapose>
        {/*    <Particles params={params} className="particles-wrapper" /> */}
    </section>
);

export default HomeJuxtapose;


// WEBPACK FOOTER //
// ./src/components/home/Juxtapose/index.js